import { combineReducers } from 'redux';
import { App } from '../modules/App/redux/reducers/index';
import { UserManagement } from '../modules/UserManagement/User_list/redux/reducers';
import { Leads } from '../modules/Leads/Manage_retail/redux/reducers';
import { ManagerLeads } from '../modules/Leads/Manager_special/redux/reducers';
import { PlatformManagement } from '../modules/PlatformManagement/BikeManagement/redux/reducers/index';

export const rootReducer = combineReducers({
    App,
    Leads,
    ManagerLeads,
    PlatformManagement,
    UserManagement,
});



// WEBPACK FOOTER //
// ./src/redux/combine_reducers.js